import { ReactNode } from 'react';

import { colors } from '../../../../colors';
import { BubbleTextIcon } from '../../../icons';
import { Box } from '../../../Layout';

type ActivityItemMenuProps = {
    menu: ReactNode;
    hasThread: boolean;
    hasUnreadNotification: boolean;
};

export const ActivityItemMenu = ({ menu, hasThread, hasUnreadNotification }: ActivityItemMenuProps) => {
    return (
        <Box
            display="flex"
            height="100%"
            alignSelf="flex-start"
            flexShrink={0}
            flexDirection="column"
            justifyContent="space-between"
        >
            {menu}

            {hasThread && <BubbleTextIcon color={hasUnreadNotification ? colors.teal[500] : colors.bluegray[500]} />}
        </Box>
    );
};
